<template>

<!-- <div class="ibayaq-breadcrumbs mb-3">
    <a href="#" style="text-decoration: none;margin-right:5px;" @click="back">
        <i class="mdi mdi-keyboard-backspace font-16 me-2"></i> 
        Kembali 
    </a>
    <template v-if="$page.props.auth.user.id > 0">
    <a href="#" style="text-decoration: none;margin-right:5px;" @click="logout">
        <i class="mdi mdi-account font-16 me-2"></i> 
        Logout 
    </a>
    <a href="#" style="text-decoration: none;" @click="password">
        <i class="mdi mdi-account-edit font-16 me-2"></i> 
        Ubah Kata Laluan 
    </a>
    </template>
</div> -->

</template>

<script type="text/javascript">

	export default {
	components: {

	},
	setup () {

	},
	props: {
	    auth: [Array, Object],
        link: [String],
	},
	data() {
	    return {
	  no_rujukan: '',
	  senarai : [],
	  total_carian : 0.00,
	  total_pilih : 0.00,
	  cari : 0
	}},
	methods: {
        back() {
            window.history.back();
        },
        activetab(active) {
            return this.link == active ? 'nav-link active' : 'nav-link';
        },
        logout() {
            this.$inertia.get('logout')
        },
	    password() {
            this.$inertia.get('changePassword')
        },
	},
    mounted() {
        // override default setting
        console.log(this.link);
    
        
        
    }
}
</script>